import { TextInput } from "@mantine/core"
import { MagnifyingGlassIcon, XIcon } from "@phosphor-icons/react";
import { useState } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  value?: string
  onChange?: (value: string) => void
  onSearch?: (value: string) => void
  placeholder?: string
  w?: string | number
}

export function OdooSearchBar({ value: controlledValue, onChange, onSearch, placeholder, w }: Props) {
  const [internalValue, setInternalValue] = useState("")
  const { t } = useTranslation("common")
  const value = controlledValue ?? internalValue
  const resolvedPlaceholder = placeholder ?? t("search.placeholder")

  const handleChange = (val: string) => {
    if (controlledValue === undefined) setInternalValue(val)
    onChange?.(val)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") onSearch?.(value)
  }

  const handleClear = () => {
    handleChange("")
    onSearch?.("")
  }

  return (
    <TextInput
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      onKeyDown={handleKeyDown}
      placeholder={resolvedPlaceholder}
      leftSection={<MagnifyingGlassIcon size={16} />}
      rightSection={value ? <XIcon size={14} style={{ cursor: "pointer" }} onClick={handleClear} /> : null}
      size="sm"
      w={w}
      styles={{
        input: {
          borderRadius: 8,
          border: "1.5px solid var(--mantine-color-gray-3)",
          "&:focus": { borderColor: "var(--mantine-color-brand-6)" },
        },
      }}
    />
  )
}
